import * as React from 'react';

import {Stack, Text, ThemeIcon} from '@mantine/core';
import {observer} from 'mobx-react';

export interface IPlaceholderProps {
    title: string;
    subtitle?: string;
    icon?: React.ReactNode;
    button?: React.ReactNode;
    color?: string;
}

export const Placeholder: React.FC<IPlaceholderProps> = observer((props) => {
    const {title, subtitle, icon, button, color = 'dimmed', ...otherProps} = props;

    return (
        <Stack align={'center'} {...otherProps} w={'100%'} p={'md'} gap={'sm'}>
            <ThemeIcon hidden={!icon} size={'xl'} variant="light" color={color} radius={'xl'}>
                {icon}
            </ThemeIcon>
            <Text c={color} size={'sm'} fw={600} ta={'center'}>
                {title}
            </Text>
            {subtitle && (
                <Text c={color} size={'xs'} ta={'center'}>
                    {subtitle}
                </Text>
            )}
            {button && button}
        </Stack>
    );
});
